import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
    ApplicationTrustedDomainValue,
    ApplicationId,
} from 'yeself-common/typings/application/Application';

import { updateApplicationTrustedDomainsRequest } from 'Console/data/applicationDetail/settings/SettingsAction';

import { selectTrutedDomains } from 'Console/data/applicationDetail/settings/SettingsSelector';

import TrustedDomainsForm from './TrustedDomainsForm';

type TrustedDomainsProps = {
    applicationId: ApplicationId;
};

const TrustedDomains = ({ applicationId }: TrustedDomainsProps): React.ReactElement | null => {
    const dispatch = useDispatch();

    const trustedDomains = useSelector(selectTrutedDomains);

    const handleOnChange = useCallback(
        (value: ApplicationTrustedDomainValue[]) => {
            dispatch(updateApplicationTrustedDomainsRequest(applicationId, value));
        },
        [dispatch, applicationId]
    );

    return <TrustedDomainsForm initialValue={trustedDomains} onChange={handleOnChange} />;
};

export default TrustedDomains;
